import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IFindNumberOfSheetsEnabledForAccelerationResult } from './FindNumberOfSheetsEnabledForAccelerationRequest';

export interface IFindAcceleratedViewLimitInfoParams {
}

export interface IFindAcceleratedViewLimitInfoResult extends IFindNumberOfSheetsEnabledForAccelerationResult {
  acceleratedViewLimit: number;
}

export class FindAcceleratedViewLimitInfo extends
    Request<IFindAcceleratedViewLimitInfoParams, IFindAcceleratedViewLimitInfoResult> {
  constructor() {
    super('findAcceleratedViewLimitInfo', {});
  }
}
